export default "__VITE_ASSET__mr0pZnK$__"